import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const sessionExpirationInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  // Evitar errores en SSR
  const canUseStorage = typeof window !== 'undefined' && !!window.localStorage;
  const user = canUseStorage ? localStorage.getItem('user') : null;
  const expiration = canUseStorage ? localStorage.getItem('session_expiration') : null;

  // 🚨 Sesión expirada: limpiar y bloquear el request
  if (user && expiration && Date.now() >= Number(expiration)) {
    if (canUseStorage) {
      localStorage.removeItem('user');
      localStorage.removeItem('session_expiration');
    }
    router.navigate(['/login']);
    return throwError(() => new Error('Sesión expirada'));
  }

  // Dejar pasar el request y manejar 401 centralmente
  return next(req).pipe(
    catchError(err => {
      if (err && err.status === 401) {
        if (canUseStorage) {
          localStorage.removeItem('user');
          localStorage.removeItem('session_expiration');
        }
        router.navigate(['/login']);
      }
      return throwError(() => err);
    })
  );
};